import type { IDatasetDetailsModel, IDatasetValuesModel } from './model/datasetDetailsModel'
import utils from '@/services/utils'
import Net from '@/services/net'

export function getDatasetDetails(sellerId: number, datasetId: number) {
  return Net.t1v2.get<IDatasetDetailsModel>(`/sellers/${sellerId}/datasets/${datasetId}`)
}

export function getDatasetValues(sellerId: number, datasetId: number, page?: number, pageSize?: number, filter?: string) {
  const params = new URLSearchParams()
  if (utils.isDefined(page)) {
    params.set('page', page.toString())
  }
  if (utils.isDefined(pageSize)) {
    params.set('pageSize', pageSize.toString())
  }
  if (utils.isDefined(filter) && filter.trim() !== '') {
    params.set('filter', filter)
  }
  return Net.t1v2.get<IDatasetValuesModel[]>(`/sellers/${sellerId}/datasets/${datasetId}/values?${params.toString()}`)
}

export function getDatasetValueById(sellerId: number, datasetId: number, dataId: number) {
  return Net.t1v2.get<IDatasetValuesModel>(`/sellers/${sellerId}/datasets/${datasetId}/values/${dataId}`)
}
